import { forwardRef } from 'react';

import { SvgStyled } from '@sternum/web/icons/icons.styles';
import { IconProps } from '@sternum/web/icons/icons.types';

export const TableIcon = forwardRef<SVGSVGElement, IconProps>(function TableIcon(
  { color = '', height = 12, width = 12, hasCursorPointer = false, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.8369 13.2868C1.59944 12.2183 1.5 10.8275 1.5 9C1.5 7.17251 1.59944 5.78167 1.8369 4.7132C2.07312 3.6503 2.42615 3.00071 2.85391 2.57295C3.68797 1.73889 5.26578 1.30083 9 1.30083C12.7342 1.30083 14.312 1.73889 15.1461 2.57295C15.5739 3.00071 15.9269 3.6503 16.1631 4.7132C16.4006 5.78167 16.5 7.17251 16.5 9C16.5 10.8275 16.4006 12.2183 16.1631 13.2868C15.9269 14.3497 15.5739 14.9993 15.1461 15.427C14.312 16.2611 12.7342 16.6992 9 16.6992C5.26578 16.6992 3.68797 16.2611 2.85391 15.427C2.42615 14.9993 2.07312 14.3497 1.8369 13.2868ZM9 18C1.5885 18 0 16.4115 0 9C0 1.5885 1.5885 0 9 0C16.4115 0 18 1.5885 18 9C18 16.4115 16.4115 18 9 18Z"
        fill={color || 'currentColor'}
      />
      <path d="M1.5 4.5H16.5V6H1.5V4.5Z" fill={color || 'currentColor'} />
      <path d="M7.49999 4.5L7.5 17.5022L5.99999 17.4097L6 4.5H7.49999Z" fill={color || 'currentColor'} />
    </SvgStyled>
  );
});
